import { BBSDTO } from '../../../src_server/entity/dto/BBSDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';


import { TeacherBbs } from '../../../src_server/entity/generated/TeacherBbs';export class BBSService extends GeneratedBizBase{
  async addNewThread(bbs: TeacherBbs): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BBSService/addNewThread', arguments);
  }
  async getAllThread(): Promise<Response<BBSDTO[]>> {
    return super.restCall<Response<BBSDTO[]>>('get', '/v1/BBSService/getAllThread', arguments);
  }
  async getSubThread(base_thread_id: number): Promise<Response<BBSDTO[]>> {
    return super.restCall<Response<BBSDTO[]>>('get', '/v1/BBSService/getSubThread', arguments);
  }
  async update(bbs: TeacherBbs): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BBSService/update', arguments);
  }
  async deleteLogical(thread_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BBSService/deleteLogical', arguments);
  }
}
